module.exports = __webpack_public_path__ + "static/img/loginline.0fdfafd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginline.jpg
// module id = 368
// module chunks = 22